const scrollbar = {
    hidden: {
        "&::-webkit-scrollbar": {width: 0, background: "transparent"},
        "&::-webkit-scrollbar-thumb": {display: "none"}
    },
    styled: {
        "&::-webkit-scrollbar": {width: "7px", height: "7px"},
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#EBEEF2",
            borderRadius: "100px",
            margin: "4px"
        },
        "&::-webkit-scrollbar-thumb:hover": {backgroundColor: "#718096"},
        "&::-webkit-scrollbar-track": {background: "white"}
    }
};

const shaddow = { base: "none", md: "0px 0px 8px 0px #1B242C14" };

export {scrollbar, shaddow};

